import { STATES, ELEMENTS } from "@/constants/EntityConstants";

const SEPARATOR = ".";
const SEPARATOR_DOM = "_";

const IDUtils = () => {
  const getDOMID = (...args) => {
    const id = args.length === 1 ? args[0] : args.join(SEPARATOR_DOM);
    return id.replace(/\./g, SEPARATOR_DOM);
  };

  /**
   * Joins items into a single string id with SEPARATOR as the delimiter
   * @param  {...any} args
   * @returns {string}
   */
  const getID = (...args) => (args.length === 1 ? args[0] : args.join(SEPARATOR));

  /**
   * Joins array path with separator into string with SEPARATOR as the delimiter
   * @param {string[]} path
   * @returns {string} - Joined path string
   */
  const getPathID = (path) => path.join(SEPARATOR);

  /**
   * Splits id string into array parts. Removes part of the id if n is provided.
   * @param {Array<string> | string} id - Id string to be split
   * @param {number=} dropNumber - number of items to remove from the beginning of the id array
   * @returns
   */
  const getArray = (id, dropNumber) => {
    const arr = Array.isArray(id) ? id : id.split(SEPARATOR);
    return dropNumber ? arr.slice(dropNumber) : arr;
  };

  const isRegularElementPath = (path) => path.length === 3 && path[1] === ELEMENTS;
  const isStateElementPath = (path) => path[1] === STATES && path[3] === ELEMENTS;
  const isRegularContainedElementPath = (path) => path[1] === ELEMENTS && path[3] === ELEMENTS;
  const isStateContainedElementPath = (path) => isStateElementPath(path) && path[5] === ELEMENTS;

  const getElementContainerFromPath = (path) =>
    isRegularContainedElementPath(path) || isStateContainedElementPath(path)
      ? path.slice(0, -2)
      : null;

  return {
    getDOMID,
    getID,
    getPathID,
    getArray,
    isRegularElementPath,
    isStateElementPath,
    isRegularContainedElementPath,
    isStateContainedElementPath,
    getElementContainerFromPath,
  };
};

export default IDUtils();
export { SEPARATOR, SEPARATOR_DOM };
